import client from '../client';

export const organizationApi = {
  create: async (data) => {
    const response = await client.post('/organizations/', data);
    return response.data;
  },

  getAll: async (page = 1, size = 10) => {
    const response = await client.get(`/organizations/?page=${page}&size=${size}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await client.get(`/organizations/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await client.patch(`/organizations/${id}`, data);
    return response.data;
  },

  getSchools: async (organizationId) => {
    const response = await client.get(`/organizations/organizations/${organizationId}/schools`);
    return response.data;
  },
};
